import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.8",
      d: "M16 3.9c1.102 0 2.12.348 2.953.94A5.1 5.1 0 0 1 21.1 9c0 3.371-1.52 5.853-3.368 7.64-1.86 1.801-4.024 2.867-5.194 3.355a1.39 1.39 0 0 1-1.076 0 18 18 0 0 1-1.04-.476C7.568 18.106 2.9 14.884 2.9 9a5.1 5.1 0 0 1 8.5-3.802l.6.537.6-.537A5.08 5.08 0 0 1 16 3.9Z"
    }, null, -1)
  ])))
}
export default { render: render }